const gamerules = {
    'zh-cn': {
        baccarat:
            '<h3>简介:</h3>' +
            '<p>长期以来，百家乐是亚洲、欧洲和拉丁美洲最受欢迎的游戏之一，玩法简单，却刺激紧张!</p>' +
            '<h3>如何胜出:</h3>' +
            '<p>百家乐中将发两份牌&lt;&lt;庄家&gt;&gt;和&lt;&lt;闲家&gt;&gt;，总数得9点或最接近9 点的一家胜出。 </p>' +
            '<h3>操作及下注指南:</h3>' +
            '<ol>' +
            '<li>点击下注的筹码，再点击桌上下注任何一块(闲家、庄家或平局)。 </li>' +
            '<li>闲家和庄家将获发两张牌，加起来等于10作0点，总和超过9，则只算总数中的个位。 </li>' +
            '<li>任何一家拿到8或9点（天生赢家），牌局就算结束，不再补牌。 </li>' +
            '<li>派出两张牌后，如果任何一手牌的头两张牌的牌面为0至7，将依照补牌规则多发一张牌，不可以任选补牌。 </li>' +
            '<li>没有任何一手牌获得超过三张牌。 </li>' +
            '</ol>' +
            '<h3>游戏玩法：</h3>' +
            '<p>本游戏采用8副牌（每副牌52张）来进行，游戏牌数合计416张。 “闲家”“庄家”各先派两张牌，以“闲家”先发，如第一轮未分出胜负需再按“牌例”发第二轮的牌，最多每方3张牌，谁最接近9点即为胜方，而相同点数即和局。 </p>' +
            '<h3>游戏规则:</h3>' +
            '<ol>' +
            '<li>' +
            '点数计算' +
            '<table>' +
            '<thead>' +
            '<tr>' +
            '<td class="size-256 head">牌面</td>' +
            '<td class="size-256 head">点数</td>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            '<tr>' +
            '<td>2 至 9</td>' +
            '<td>根据其数值显示的点数</td>' +
            '</tr>' +
            '<tr>' +
            '<td>Ace</td>' +
            '<td>1</td>' +
            '</tr>' +
            '<tr>' +
            '<td>K或Q或J或10</td>' +
            '<td>0</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            '<p>' +
            '*当任何一家头两张牌的点数总和为8或9，就称为(天生赢家)。 ' +
            '</p>' +
            '<p>' +
            '*派出两张牌后，如果需要补牌，将依照博牌规则向需要补牌方多发一张牌' +
            '</p>' +
            '<p>例子:</p>' +
            '<p>4 + 2 + 6 = 2</p>' +
            '<p>5 + 6 + 8 = 9</p>' +
            '<p>10 + 10 + 10 = 0</p>' +
            '<br />' +
            '</li>' +
            '<li>' +
            '补牌规则:' +
            '<table>' +
            '<thead>' +
            '<tr>' +
            '<td class="size-131 head">' +
            '闲两牌合计点数' +
            '</td>' +
            '<td class="size-143 head">闲家</td>' +
            '<td class="size-194 head">' +
            '庄两牌合计点数' +
            '</td>' +
            '<td class="size-432 head">庄家</td>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            '<tr>' +
            '<td>0</td>' +
            '<td>必须博牌</td>' +
            '<td>0</td>' +
            '<td>必须博牌</td>' +
            '</tr>' +
            '<tr>' +
            '<td>1</td>' +
            '<td>必须博牌</td>' +
            '<td>1</td>' +
            '<td>必须博牌</td>' +
            '</tr>' +
            '<tr>' +
            '<td>2</td>' +
            '<td>必须博牌</td>' +
            '<td>2</td>' +
            '<td>必须博牌</td>' +
            '</tr>' +
            '<tr>' +
            '<td>3</td>' +
            '<td>必须博牌</td>' +
            '<td>3</td>' +
            '<td>' +
            '若闲家博得第三张牌是8点，庄家不得博牌' +
            '</td>' +
            '</tr>' +
            '<tr>' +
            '<td>4</td>' +
            '<td>必须博牌</td>' +
            '<td>4</td>' +
            '<td>' +
            '若闲家博得第三张牌是0，1，8，9点，' +
            '庄家不得博牌' +
            '</td>' +
            '</tr>' +
            '<tr>' +
            '<td>5</td>' +
            '<td>必须博牌</td>' +
            '<td>5</td>' +
            '<td>' +
            '若闲家博得第三张牌是0，1，2，3，8，9点，' +
            '庄家不得博牌' +
            '</td>' +
            '</tr>' +
            '<tr>' +
            '<td>6</td>' +
            '<td>不得博牌</td>' +
            '<td>6</td>' +
            '<td>' +
            '若闲家博得第三张牌是6 或' +
            '7点，庄家必须博牌' +
            '</td>' +
            '</tr>' +
            '<tr>' +
            '<td>8</td>' +
            '<td>例牌，即定胜负</td>' +
            '<td>8</td>' +
            '<td>例牌，即定胜负</td>' +
            '</tr>' +
            '<tr>' +
            '<td>9</td>' +
            '<td>例牌，即定胜负</td>' +
            '<td>9</td>' +
            '<td>例牌，即定胜负</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            '<p>' +
            '*庄闲任何一方两牌合计8、9点为例牌，对方不须博牌，即定胜负。庄闲两方头两张牌各得6或7点，即和局。 ' +
            '</p>' +
            '</li>' +
            '</ol>' +
            '<h3>派彩赔率：</h3>' +
            '<p>' +
            '本游戏为玩家提供百家乐玩法和免佣百家乐玩法。这两种玩法的博牌规则和投注种类一致，但投注庄的派彩方式有区别。其投注种类与派彩分别如下：' +
            '</p>' +
            '<table>' +
            '<thead>' +
            '<tr>' +
            '<td class="size-256 head">投注项目</td>' +
            '<td class="size-256 head">赔率</td>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            '<tr>' +
            '<td>闲家</td>' +
            '<td>1:1（开和局时退回下注金额）</td>' +
            '</tr>' +
            '<tr>' +
            '<td>庄家</td>' +
            '<td>1:0.95（开和局时退回下注金额）</td>' +
            '</tr>' +
            '<tr>' +
            '<td>和局</td>' +
            '<td>1:8</td>' +
            '</tr>' +
            '<tr>' +
            '<td>闲对子</td>' +
            '<td>1:11</td>' +
            '</tr>' +
            '<tr>' +
            '<td>庄对子</td>' +
            '<td>1:11</td>' +
            '</tr>' +
            '<tr>' +
            '<td>SUPER6</td>' +
            '<td>1：12</td>' +
            '</tr>' +
            '<tr>' +
            '<td>龙7</td>' +
            '<td>1 ：40</td>' +
            '</tr>' +
            '<tr>' +
            '<td>熊8</td>' +
            '<td>1 ：25</td>' +
            '</tr>' +
            '<tr>' +
            '<td>大老虎</td>' +
            '<td>1 ：50</td>' +
            '</tr>' +
            '<tr>' +
            '<td>小老虎</td>' +
            '<td>1 ：22</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            '<h3 class="title">特殊投注说明:</h3>' +
            '<p>• <b>SUPER6：</b>庄家以合计6点胜出。</p>' +
            '<p> • <b>龙7：</b>庄家必为3张牌，且点数合计为7点，庄家赢。 </p>' +
            '<p> • <b>熊8：</b>闲家必为3张牌，且点数合计为8点，闲家赢。 </p>' +
            '<p> • <b>大老虎：</b>庄家必为3张牌，且点数合计为6点，庄家赢。 </p>' +
            '<p> • <b>小老虎：</b>庄家必为2张牌，且点数合计为6点，庄家赢。 </p>' +
            '<p>  大小老虎和SUPER6不可同时下注。 </p>' +
            '<h3 class="title"> 备注：每靴第35局以后不接受龙7、熊8、大老虎、小老虎投注。 </h3>' +
            '<h3 class="title">庄/闲对子:</h3>' +
            '<p> 庄的第一张和第二张牌点数相同，则为庄对子。闲的第一张和第二张牌点数相同，则为闲对子。 </p>' +
            '<p><b>例牌定义：首两牌结果为8或9点</b></p>' +
            '<p><b>非例牌定义：例牌之外的所有情况</b></p>' +
            '<h3 class="title">请注意 :</h3>' +
            '<p> • 荷官发牌时，偶有系统无法判读状况时，此时荷官将重新扫描，直到系统能够完整判读(如遇故障因素将注销所有相关注单/派彩)。 </p>' +
            '<p> • 如遇结算错误，按照当期视频结果重新结算。 </p>',
        dragontiger:
            '<h3>简介:</h3>' +
            '<p>一个以牌面点数大小来决定输赢的博彩游戏，简单易学，让玩家完全体验赌场的趣味!</p>' +
            '<h3>如何胜出:</h3>' +
            '<p>正确预计两家&lt;&lt;龙&gt;&gt; 和&lt;&lt;虎&gt;&gt;的点数比较大。</p>' +
            '<h3>操作及下注指南:</h3>' +
            '<ol>' +
            '<li>点击下注的筹码，再点击桌上下注任何一块 (龙、虎或平局 )。</li>' +
            '<li>荷官只派两门牌，每门各派一只牌，即龙与虎，双方斗大。</li>' +
            '</ol>' +
            '<h3>游戏玩法：</h3>' +
            '<ol>' +
            '<li>牌面的先比点数，K为最大牌，A为最小。如点数相同，则比较花色，黑桃&gt;红桃&gt;梅花&gt;方块</li>' +
            '<li>荷官先派发第一张牌于龙的位置，而第二张牌派发到虎的位置，点数较大的胜出，点数相同花色大的胜出</li>' +
            '</ol>' +
            '<h3>派彩赔率:</h3>' +
            '<table>' +
            '<thead>' +
            '<tr>' +
            '<td class="size-256 head">投注项目</td>' +
            '<td class="size-256 head">赔率</td>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            '<tr>' +
            '<td>龙</td>' +
            '<td>1 ：1 (开和局时，全输)</td>' +
            '</tr>' +
            '<tr>' +
            '<td>虎</td>' +
            '<td>1 ：1 (开和局时，全输)</td>' +
            '</tr>' +
            '<tr>' +
            '<td>和</td>' +
            '<td>1：8</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            '<h3>请注意 :</h3>' +
            '<p>' +
            '•' +
            '荷官发牌时，偶有系统无法判读状况时，此时荷官将重新扫描，直到系统能够完整判读(如遇故障因素将注销所有相关注单/派彩)。' +
            '</p>' +
            '<p>• 如遇结算错误，按照当期视频结果重新结算。</p>'
    },
    'zh-hk': {
        baccarat:
            '<h3>簡介：</h3>' +
            '<p>長期以來，百家樂是亞洲、歐洲和拉丁美洲最受歡迎的遊戲之一，玩法簡單，卻刺激緊張!</p>' +
            '<h3>如何勝出：</h3>' +
            '<p>百家樂中將發兩份牌&lt;&lt;莊家&gt;&gt;和&lt;&lt;閒家&gt;&gt;，總數得9點或最接近9 點的一家勝出。</p>' +
            '<h3>操作及下注指南：</h3>' +
            '<ol>' +
            '<li>點擊下注的籌碼，再點擊桌上下注任何一塊（閒家、莊家或平局）。</li>' +
            '<li>閒家和莊家將獲發兩張牌，加起來等於10作0點，總和超過9，則只算總數中的個位。</li>' +
            '<li>任何一家拿到8或9點 （天生贏家），牌局就算結束，不再補牌。</li>' +
            '<li>派出兩張牌後，如果任何一手牌的頭兩張牌的牌面為0至7，將依照補牌規則多發一張牌，不可以任選補牌。</li>' +
            '<li>沒有任何一手牌獲得超過三張牌。</li>' +
            '</ol>' +
            '<h3>遊戲玩法：</h3>' +
            '<p>本遊戲採用8副牌（每副牌52張）來進行，遊戲牌數合計416張。"閒家”"莊家”各先派兩張牌，以"閒家”先發，如第一輪未分出勝負需再按"牌例”發第二輪的牌，最多每方3張牌，誰最接近9點即為勝方，而相同點數即和局。</p>' +
            '<h3>遊戲規則：</h3>' +
            '<ol>' +
            '<li>' +
            '點數計算' +
            '<table>' +
            '<thead>' +
            '<tr>' +
            '<td class="size-256 head">牌面</td>' +
            '<td class="size-256 head">點數</td>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            '<tr>' +
            '<td>2至9</td>' +
            '<td>根據其數值顯示的點數</td>' +
            '</tr>' +
            '<tr>' +
            '<td>Ace</td>' +
            '<td>1</td>' +
            '</tr>' +
            '<tr>' +
            '<td>K或Q或J或10</td>' +
            '<td>0</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            '<p>' +
            '*當任何一家頭兩張牌的點數總和為8或9，就稱為（天生贏家）。' +
            '</p>' +
            '<p>' +
            '*派出兩張牌後，如果需要補牌，將依照博牌規則向需要補牌方多發一張牌' +
            '</p>' +
            '<p>例子：</p>' +
            '<p>4+2+6=2</p>' +
            '<p>5 + 6 +8 = 9</p>' +
            '<p>10 + 10 + 10 = 0</p>' +
            '<br />' +
            '</li>' +
            '<li>' +
            '補牌規則：' +
            '<table>' +
            '<thead>' +
            '<tr>' +
            '<td class="size-131 head">' +
            '閒兩牌合計點數' +
            '</td>' +
            '<td class="size-143 head">閒家</td>' +
            '<td class="size-194 head">' +
            '莊兩牌合計點數' +
            '</td>' +
            '<td class="size-432 head">莊家</td>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            '<tr>' +
            '<td>0</td>' +
            '<td>必須博牌</td>' +
            '<td>0</td>' +
            '<td>必須博牌</td>' +
            '</tr>' +
            '<tr>' +
            '<td>1</td>' +
            '<td>必須博牌 </td>' +
            '<td>1</td>' +
            '<td>必須博牌</td>' +
            '</tr>' +
            '<tr>' +
            '<td>2</td>' +
            '<td>必須博牌</td>' +
            '<td>2</td>' +
            '<td>必須博牌</td>' +
            '</tr>' +
            '<tr>' +
            '<td>3</td>' +
            '<td>必須博牌 </td>' +
            '<td>3</td>' +
            '<td>' +
            '若閒家博得第三張牌是8點，莊家不得博牌' +
            '</td>' +
            '</tr>' +
            '<tr>' +
            '<td>4</td>' +
            '<td>必須博牌</td>' +
            '<td>4</td>' +
            '<td>' +
            '閒家博得第三張牌是0，1，8，9點，莊家不得博牌' +
            '</td>' +
            '</tr>' +
            '<tr>' +
            '<td>5</td>' +
            '<td>必須博牌 </td>' +
            '<td>5</td>' +
            '<td>' +
            '若閒家博得第三張牌是0，1，2，3，8，9點 ，莊家不得博牌' +
            '</td>' +
            '</tr>' +
            '<tr>' +
            '<td>6</td>' +
            '<td>不得博牌 </td>' +
            '<td>6</td>' +
            '<td>' +
            '若閒家博得第三張牌是6或7點，莊家必須博牌' +
            '</td>' +
            '</tr>' +
            '<tr>' +
            '<td>8</td>' +
            '<td>例牌，即定勝負</td>' +
            '<td>8</td>' +
            '<td>例牌，即定勝負</td>' +
            '</tr>' +
            '<tr>' +
            '<td>9</td>' +
            '<td>例牌，即定勝負 </td>' +
            '<td>9</td>' +
            '<td>例牌，即定勝負 </td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            '<p>' +
            '*莊閒任何一方兩牌合計8、9點為例牌，對方不須博牌，即定勝負。莊閒兩方頭兩張牌各得6或7點，即和局。' +
            '</p>' +
            '</li>' +
            '</ol>' +
            '<h3>派彩賠率：</h3>' +
            '<p>' +
            '本遊戲為玩家提供百家樂玩法和免傭百家樂玩法。這兩種玩法的博牌規則和投注種類一致，但投注莊的派彩方式有區別。其投注種類與派彩分別如下：  ' +
            '</p>' +
            '<table>' +
            '<thead>' +
            '<tr>' +
            '<td class="size-256 head">投注項目</td>' +
            '<td class="size-256 head">賠率</td>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            '<tr>' +
            '<td>閒家 </td>' +
            '<td>1:1 （開和局時退回下注金額）</td>' +
            '</tr>' +
            '<tr>' +
            '<td>莊家 </td>' +
            '<td>1:0.95 （開和局時退回下注金額）</td>' +
            '</tr>' +
            '<tr>' +
            '<td>和局</td>' +
            '<td>1:8</td>' +
            '</tr>' +
            '<tr>' +
            '<td>閒對子</td>' +
            '<td>1:11</td>' +
            '</tr>' +
            '<tr>' +
            '<td>莊對子 </td>' +
            '<td>1:11</td>' +
            '</tr>' +
            '<tr>' +
            '<td>SUPER6</td>' +
            '<td>1：12</td>' +
            '</tr>' +
            '<tr>' +
            '<td>龍7</td>' +
            '<td>1 ：40</td>' +
            '</tr>' +
            '<tr>' +
            '<td>熊8</td>' +
            '<td>1 ：25</td>' +
            '</tr>' +
            '<tr>' +
            '<td>大老虎</td>' +
            '<td>1 ：50</td>' +
            '</tr>' +
            '<tr>' +
            '<td>小老虎</td>' +
            '<td>1 ：22</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            '<h3 class="title">特殊投注說明:</h3>' +
            '<p>• <b>SUPER6：</b>莊家以合計6點勝出。</p>' +
            '<p> • <b>龍7：</b>莊家必為3張牌，且點數合計為7點，莊家贏。 </p>' +
            '<p> • <b>熊8：</b>閒家必為3張牌，且點數合計為8點，閒家贏。 </p>' +
            '<p> • <b>大老虎：</b>莊家必為3張牌，且點數合計為6點，莊家贏。 </p>' +
            '<p> • <b>小老虎：</b>莊家必為2張牌，且點數合計為6點，莊家贏。 </p>' +
            '<p>  大小老虎和SUPER6不可同時下注。 </p>' +
            '<h3 class="title"> 備註：每靴第35局以後不接受龍7、熊8、大老虎、小老虎投注。 </h3>' +
            '<h3 class="title">莊/閒對子:</h3>' +
            '<p> 莊的第一張和第二張牌點數相同，則為莊對子。閒的第一張和第二張牌點數相同，則為閒對子。 </p>' +
            '<p><b>例牌定義：首兩牌結果為8或9點</b></p>' +
            '<p><b>非例牌定義：例牌之外的所有情況</b></p>' +
            '<h3 class="title">請注意 :</h3>' +
            '<p> • 荷官發牌時，偶有系統無法判讀狀況時，此時荷官將重新掃描，直到系統能夠完整判讀(如遇故障因素將註銷所有相關注單/派彩)。 </p>' +
            '<p> • 如遇結算錯誤，按照當期視頻結果重新結算。 </p>',
        dragontiger:
            '<h3>簡介:</h3>' +
            '<p>一個以牌面點數大小來決定輸贏的博彩遊戲，簡單易學，讓玩家完全體驗賭場的趣味!</p>' +
            '<h3>如何勝出:</h3>' +
            '<p>正確預期兩家&lt;&lt;龍&gt;&gt; 和&lt;&lt;虎&gt;&gt;的點數比較大。 </p>' +
            '<h3>操作及下注指南:</h3>' +
            '<ol>' +
            '<li>點擊下注的籌碼，再點擊桌上下注任何一塊 (龍、虎或平局 )。 </li>' +
            '<li>荷官只派兩門牌，每門各派一張牌，即龍與虎，雙方斗大。 </li>' +
            '</ol>' +
            '<h3>遊戲玩法：</h3>' +
            '<ol>' +
            '<li>牌面的先比點數，K為最大牌，A為最小。如點數相同，則比較花色，黑桃&gt;紅桃&gt;梅花&gt;方塊</li>' +
            '<li>荷官先派發第一張牌於龍的位置，而第二張牌派發到虎的位置，點數較大的勝出，點數相同花色大的勝出</li>' +
            '</ol>' +
            '<h3>派彩賠率:</h3>' +
            '<table>' +
            '<thead>' +
            '<tr>' +
            '<td class="size-256 head">投注項目</td>' +
            '<td class="size-256 head">賠率</td>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            '<tr>' +
            '<td>龍</td>' +
            '<td>1 ：1 (開和局時，全輸)</td>' +
            '</tr>' +
            '<tr>' +
            '<td>虎</td>' +
            '<td>1 ：1 (開和局時，全輸)</td>' +
            '</tr>' +
            '<tr>' +
            '<td>和</td>' +
            '<td>1：8</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            '<h3>請注意 :</h3>' +
            '<p>' +
            '•' +
            '荷官發牌時，偶有系統無法判讀狀況時，此時荷官將重新掃描，直到系統能夠完整判讀(如遇故障因素將註銷所有相關注單/派彩)。 ' +
            '</p>' +
            '<p>• 如遇結算錯誤，依當期影片結果重新結算。 </p>'
    }
}

export default gamerules
